import { useDispatch, useSelector } from "react-redux";
import { store } from "../store.js";
import { bindActionCreators } from "redux";
import { useMemo, useRef } from "react";
const { dispatch } = store;
export const useAppDispatch = useDispatch.withTypes();
export const useAppSelector = useSelector.withTypes();
export function useAppAction(creator) {
    return useMemo(() => bindActionCreators(creator, dispatch), [creator]);
}
export function useInitializeInStoreDuringRender(creator, payload) {
    const isInitialized = useRef(false);
    if (!isInitialized.current && payload) {
        dispatch(creator(payload));
        isInitialized.current = true;
    }
}
;
